<mat-card class="card">
    <mat-card-header>
        <div mat-card-avatar class="example-header-image"></div>
        <mat-card-title>{{data.text}}</mat-card-title>
        <mat-card-subtitle>{{'model.wait' | translate}}</mat-card-subtitle>
    </mat-card-header>
    <img mat-card-image [src]="data.image">
    <mat-card-content>

    </mat-card-content>
</mat-card>